import React from "react";
import { HiDownload } from "react-icons/hi";
import materials from "../../utils/materialFormats.json";

const Materials = () => {
  // Group materials by type
  const groupedMaterials = materials.reduce((acc, material) => {
    if (!acc[material.type]) acc[material.type] = [];
    acc[material.type].push(material);
    return acc;
  }, {});

  return (
    <div className="materials-page ">
      <h1 className="text-2xl text-white font-bold mb-4 text-center">Materials</h1>
      {Object.entries(groupedMaterials).map(([type, items]) => (
        <div key={type} className="mb-8">
          <h2 className="text-xl font-semibold mb-4 text-center text-blue-500">
            {type}s
          </h2>
          <div className="flex overflow-x-auto space-x-4">
            {items.map((material) => (
              <div
                key={material.id}
                className="material-card min-w-[300px] p-1 border rounded-lg shadow hover:shadow-lg transition-all"
              >
                <h3 className="text-lg font-semibold mb-2">{material.title}</h3>
                {type === "Video" && (
                  <video
                    controls
                    className="w-full h-48 rounded-lg mb-4"
                    src={material.src}
                  />
                )}
                {type === "Book" && (
                  <div className="flex items-center gap-3">
                    <p className="text-gray-600">Downloadable Book</p>
                    <a
                      href={material.downloadLink}
                      download
                      className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                    >
                      <HiDownload size={20} />
                    </a>
                  </div>
                )}
                {type === "Image" && (
                  <img
                    className="w-full h-48 object-cover rounded-lg mb-4"
                    src={material.src}
                    alt={material.title}
                  />
                )}
                {type === "Audio" && (
                  <audio controls className="w-full">
                    <source src={material.src} type="audio/mpeg" />
                    Your browser does not support the audio element.
                  </audio>
                )}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Materials;
